import React from 'react';
import { Link } from 'react-router-dom';

import  images1  from '../../assets/images/image2.jpg';
import { images } from '../../assets/images';
import  EqualHeightElement  from 'react-equal-height';
import PageTitle from '../../Components/PageTitle';
import Events from './Events_side';
import { routes } from '../../routes';

function Newsdetail() {
    return (
        <>
            <PageTitle title="News Detail" />
            <section className="blog_detail_section">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="blog_detail_area">
                                <div className="row">
                                    <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
                                        <div className="blog_detail_content">
                                            <div className="img_area">
                                                <img src={images1}  />
                                            </div>
                                            <div className="date">Sat, November 05 </div>
                                            <div className="content_box">
                                                <h6>
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
                                                </h6>
                                                <p>
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores.
                                                </p>
                                                <span>Lorem dolor ipsum</span>
                                                <p>
                                                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                                    Voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                                </p>
                                                <span>Sed ut perspiciatis unde omnis iste natus error</span>
                                                <p>
                                                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                                </p>
                                                <p>
                                                    Voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                                </p>
                                            </div>
                                            <div className="share">
                                                <ul>
                                                    <li>
                                                        Share:
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-facebook-f"></i></Link>
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-twitter"></i></Link>
                                                    </li>
                                                    <li>
                                                        <Link to=""><i className="fab fa-instagram"></i></Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                                        <div className="blog_sidebar">
                                            <div className="tags_box">
                                                <h6>Top Tags</h6>
                                                <ul className="list-inline">
                                                    <li className="active">
                                                        <Link to="">lorem</Link>
                                                        <div className="cross_icon">
                                                            <i className="lnr lnr-cross"></i>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <Link to="">lorem sit</Link>
                                                        <div className="cross_icon">
                                                            <i className="lnr lnr-cross"></i>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <Link to="">lorem</Link>
                                                        <div className="cross_icon">
                                                            <i className="lnr lnr-cross"></i>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <Link to="">lorem</Link>
                                                        <div className="cross_icon">
                                                            <i className="lnr lnr-cross"></i>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <Link to="">lorem sit</Link>
                                                        <div className="cross_icon">
                                                            <i className="lnr lnr-cross"></i>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <Events />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="frome-blog blog-space">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="heading-lines ps-0">
                                <h2>
                                Related Posts
                                </h2>
                            </div>
                            <div className="blog_wrap">
                                <div className="news_listing pt-4">
                                    <div className="row">
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="news_item">
                                                <div className="img_area embed-responsive embed-responsive-4by3">
                                                    <img src={images.process2} className="embed-responsive-item img-fluid" alt="..." />
                                                    <div className="upper_img">
                                                        <div className="secondary_btn">
                                                            <Link to={routes.newsdetail}>Read More</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="news_info">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="news_catg">
                                                            <Link to={routes.newsdetail}>Application Testing</Link>
                                                        </div>
                                                    </div>
                                                    <h5>
                                                        <Link to={routes.newsdetail}>Lorem ipsum dolor sit amet consectetur adipisicing elit.</Link>
                                                    </h5>
                                                    <p>
                                                        Quisquam saepe libero provident dicta suscipit aliquid facere placeat reprehenderit minima consequatur!
                                                    </p>
                                                    <hr />
                                                    <div className="news_metainfo">
                                                        <ul>
                                                            <li>
                                                                <i className="far fa-user"></i>
                                                                <span>By Admin</span>
                                                            </li>
                                                            <li>
                                                                <i className="far fa-calendar"></i>
                                                                <span>22 March, 2021</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="news_item">
                                                <div className="img_area embed-responsive embed-responsive-4by3">
                                                    <img src={images.process2} className="embed-responsive-item img-fluid" alt="..." />
                                                    <div className="upper_img">
                                                        <div className="secondary_btn">
                                                            <Link to={routes.newsdetail}>Read More</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="news_info">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="news_catg">
                                                            <Link to={routes.newsdetail}>Application Testing</Link>
                                                        </div>
                                                    </div>
                                                    <h5>
                                                        <Link to={routes.newsdetail}>Lorem ipsum dolor sit amet consectetur adipisicing elit.</Link>
                                                    </h5>
                                                    <p>
                                                        Quisquam saepe libero provident dicta suscipit aliquid facere placeat reprehenderit minima consequatur!
                                                    </p>
                                                    <hr />
                                                    <div className="news_metainfo">
                                                        <ul>
                                                            <li>
                                                                <i className="far fa-user"></i>
                                                                <span>By Admin</span>
                                                            </li>
                                                            <li>
                                                                <i className="far fa-calendar"></i>
                                                                <span>22 March, 2021</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 d-lg-block d-none">
                                            <div className="news_item">
                                                <div className="img_area embed-responsive embed-responsive-4by3">
                                                    <img src={images.process2} className="embed-responsive-item img-fluid" alt="..." />
                                                    <div className="upper_img">
                                                        <div className="secondary_btn">
                                                            <Link to={routes.newsdetail}>Read More</Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="news_info">
                                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                                        <div className="news_catg">
                                                            <Link to={routes.newsdetail}>Application Testing</Link>
                                                        </div>
                                                    </div>
                                                    <h5>
                                                        <Link to={routes.newsdetail}>Lorem ipsum dolor sit amet consectetur adipisicing elit.</Link>
                                                    </h5>
                                                    <p>
                                                        Quisquam saepe libero provident dicta suscipit aliquid facere placeat reprehenderit minima consequatur!
                                                    </p>
                                                    <hr />
                                                    <div className="news_metainfo">
                                                        <ul>
                                                            <li>
                                                                <i className="far fa-user"></i>
                                                                <span>By Admin</span>
                                                            </li>
                                                            <li>
                                                                <i className="far fa-calendar"></i>
                                                                <span>22 March, 2021</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>          
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Newsdetail;
